enum GameState {
    InProgress,
    Won,
    Lost
}

export default GameState;